import React from "react";
import "./index.scss";
import iconTitle from "../../../../assets/images/event-2024/congra-title.png";
import iconTitleWinner from "../../../../assets/images/event-2024/congra-title-winner.png";
import Snow from "../Components/animtion/Snow";
import BoxWinner from "./BoxWinner";

export default function Congratulaitons() {
  return (
    <div id="congratulaiton">
      <Snow />
      <div className="icon-title-event">
        <img src={iconTitleWinner} alt="" className="img-title-navidad" />
        <img src={iconTitle} alt="" className="img-title-navidad" />
      </div>
      <BoxWinner />
    </div>
  );
}
